// packages/shared-hooks/src/lead-activity/useDeleteLeadFile.ts
//
// `DELETE /leads/:leadId/files/:fileId` — soft-delete (`deletedAt`
// flag) plus `LEAD_FILE_DELETED` audit emit in the same transaction.
// Idempotent on the backend; the UI invalidates the capsule prefix so
// the row vanishes from the list and the feed shows the deletion event
// (#1085).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from './keys.js';

export function useDeleteLeadFile(leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<void, unknown, string>({
    mutationFn: (fileId) => client.delete<void>(`/leads/${leadId}/files/${fileId}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadActivityKeys.forLead(leadId) });
    },
  });
}
